import { createSlice } from "@reduxjs/toolkit";
import { createValuePreparer } from "./reduxUtils";
import {
  toggleTeamAllocationGroup,
  toggleUserAllocationGroup,
} from "./taskGroupingUtils";

const initialState = {
  allocationUsers: [],
  expanded: false,
};

const grouping = createSlice({
  name: "grouping",
  initialState,
  reducers: {
    setAllGroupUser: {
      prepare: createValuePreparer("allocationUsers"),
      reducer(state, action) {
        state.allocationUsers = action.payload.allocationUsers;
      },
    },
    setTeamGroupUser: {
      prepare: createValuePreparer("allocationUsers"),
      reducer(state, action) {
        state.allocationUsers = toggleTeamAllocationGroup(
          state.allocationUsers,
          action.payload.allocationUsers
        );
      },
    },
    setGroupUser: {
      prepare: createValuePreparer("allocationUsers"),
      reducer(state, action) {
        state.allocationUsers = toggleUserAllocationGroup(
          state.allocationUsers,
          action.payload.allocationUsers
        );
      },
    },
    changeGroupExpand: {
      prepare: createValuePreparer("expanded"),
      reducer(state, action) {
        state.expanded = action.payload.expanded;
      },
    },
  },
});

export const {
  setGroupUser,
  changeGroupExpand,
  setAllGroupUser,
  setTeamGroupUser,
} = grouping.actions;

export default grouping.reducer;
